import { render, staticRenderFns } from "./assetAdmin.vue?vue&type=template&id=e253936e"
import script from "./assetAdmin.vue?vue&type=script&lang=js"
export * from "./assetAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports